import CustomerId from "./CustomerId";

class CustomerIds {
  constructor(private readonly _list: CustomerId[] = []) {
  }

  public isEmpty(): boolean {
    return this._list.length <= 0;
  }

  public toList(): CustomerId[] {
    return this._list;
  }

  public has(customerId: CustomerId): boolean {
    let result = false;
    this._list.forEach(value => {
      if (value.equals(customerId)) {
        result = true;
      }
    });

    return result;
  }

  public add(customerId: CustomerId): CustomerIds {
    this._list.push(customerId);
    return new CustomerIds(this._list);
  }

  public remove(customerId: CustomerId): CustomerIds {
    const list: CustomerId[] = this._list.filter((value: CustomerId) => {
      return (value.notEquals(customerId))
    });

    return new CustomerIds(list);
  }
}

export default CustomerIds;
